import { HiOutlineSpeakerphone, HiOutlineDuplicate } from 'react-icons/hi';
import ReactMarkdown from 'react-markdown';
import { Modal } from '../site/Modal';

export const TranslationModal = ({ isOpen, onClose, word, translation, markdown }) => {
  return (
    <Modal isOpen={isOpen} title="Translation" onClose={onClose}>
      <div className="space-y-5 max-h-[70vh] overflow-y-auto">
        {/* Original Word */}
        <div className="flex items-center justify-between">
          <h3 className="text-2xl font-bold" style={{ color: 'var(--foreground)' }}>{word}</h3>
          <div className="flex gap-1">
            <button className="button-ghost p-2 rounded-full transition-colors" title="Listen">
              <HiOutlineSpeakerphone className="w-5 h-5" />
            </button>
            <button className="button-ghost p-2 rounded-full transition-colors" title="Copy">
              <HiOutlineDuplicate className="w-5 h-5" />
            </button>
          </div>
        </div>

        {/* Translation Result */}
        <div className="prose prose-sm max-w-none">
          {markdown ? (
            <ReactMarkdown>{markdown}</ReactMarkdown>
          ) : (
            <div className="p-4 rounded-xl border" style={{ background: 'var(--accent-tint)', borderColor: 'transparent' }}>
              <p className="text-lg font-medium leading-relaxed" style={{ color: 'var(--accent)' }} dir="auto">
                {translation ? translation.replace('ترجمه: ', '') : 'Loading...'}
              </p>
            </div>
          )}
        </div>
      </div>
    </Modal>
  );
};
